"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function rafThrottle(fn) {
    let ticking = false;
    return (...args) => {
        if (ticking) {
            return;
        }
        requestAnimationFrame(() => {
            fn(...args);
            ticking = false;
        });
        ticking = true;
    };
}
exports.rafThrottle = rafThrottle;
function culcSize(viewPort, vTrack, hTrack, state) {
    if (!viewPort || !vTrack || !hTrack) {
        return;
    }
    state.viewPortHeight = viewPort.clientHeight;
    state.contentHeight = viewPort.scrollHeight;
    state.vRatio = state.viewPortHeight / state.contentHeight;
    state.vThumbHeight = toFixed2(state.vRatio * state.viewPortHeight);
    state.vTrackHeight = vTrack.clientHeight;
    state.maxVThumbTop = state.vTrackHeight - state.vThumbHeight;
    state.viewPortWidth = viewPort.clientWidth;
    state.contentWidth = viewPort.scrollWidth;
    state.hRatio = state.viewPortWidth / state.contentWidth;
    state.hThumbWidth = toFixed2(state.hRatio * state.viewPortWidth);
    state.hTrackWidth = hTrack.clientWidth;
    state.maxHThumbLeft = state.hTrackWidth - state.hThumbWidth;
}
exports.culcSize = culcSize;
function resetScrollbar(vTrack, vThumb, hTrack, hThumb, state) {
    if (!vTrack || !vThumb || !hTrack || !hThumb) {
        return;
    }
    if (state.vThumbHeight < state.vTrackHeight) {
        vThumb.style.height = state.vThumbHeight + "px";
        vTrack.classList.remove("hiden");
    }
    else {
        vTrack.classList.add("hiden");
    }
    if (state.hThumbWidth < state.hTrackWidth) {
        hThumb.style.width = state.hThumbWidth + "px";
        hTrack.classList.remove("hiden");
    }
    else {
        hTrack.classList.add("hiden");
    }
}
exports.resetScrollbar = resetScrollbar;
function toFixed2(n) {
    return Math.round(n * 100) / 100;
}
exports.toFixed2 = toFixed2;
